import React from "react";

export default function Spinner() {
  return (
    <div className="animate-spin w-40 h-40 border-t-2 border-b-2 border-purple-500 rounded-full m-auto my-10"></div>
  );
}
